<template>
	<div id="divList">
        <CCard class="mb-2">
            <CCardHeader class="pt-1 pb-1">
                <span class="card-header-title">Thống kê báo cáo</span>
            </CCardHeader>
            <CCardBody class="pt-1 pb-1">
                <CRow class="mb-2">
					<CCol md="3">
						<CSelect
							:value.sync="inputStatus"
							label="Trạng thái"
							:options="listStatus"
						/>
					</CCol>
                    <CCol sm="3">
						<CSelect
							label="Kỳ báo cáo"
							:options="listPeriod"
							:value.sync="inputPeriod"
							@change="periodChange"
						/>
					</CCol>
                    <CCol md="3">
						<CInput
							v-model="inputReportYear"
                            :class="inputPeriod != -1 ? 'visible' : 'invisible'"
                            type="number"
							label="Năm"
						/>
					</CCol>
					<CCol sm="3">
						<CSelect
							:class="inputPeriod != 4 && inputPeriod != 5 && inputPeriod != -1 ? 'visible' : 'invisible'"
							label="Loại kỳ báo cáo"
							:options="listPeriodDetail"
							:value.sync="inputPeriodDetail"
						/>
					</CCol>
				</CRow>
                <CRow>
                    <CCol md="12" class="center">
                        <vs-button warn square class="custom_btn_search"  @click="getData()"><i class='bx bx-search'></i>&nbsp;Tìm kiếm</vs-button>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
        <CCard>
            <vue-good-table
                :columns="columns"
                :rows="tableData"
                styleClass="vgt-table bordered striped"
                :sort-options="{
                    enabled:false
                }"
            >
                <div slot="emptystate">Không có dữ liệu</div>
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field === 'index'">
                        <span>
                            {{props.row.originalIndex + 1}}
                        </span>
                    </div>
                        <div v-else-if="props.column.field === 'item_name'">
                        <CLink @click="viewDetail(props.row.item_code)" target="_blank">
                            {{props.row.item_name}}
                        </CLink>
                    </div>
                </template>
            </vue-good-table>
            <CRow>
                <CCol sm="12" class="" style="margin-top:10px">
                    <vs-button
                    success
                    square
                    @click="downloadReport()"
                    >
                    <i class="bx bxs-download"></i>&nbsp;Tải về</vs-button
                    >
                </CCol>
            </CRow>
        </CCard>
	</div>
</template>

<script>
	import { VueGoodTable } from "vue-good-table";
    import { mapActions, mapState } from "vuex";
	import ClientFactory from "@/api/ClientFactory";
	const api = ClientFactory.get("budgetreport");
	const apiDropdown = ClientFactory.get("dropdowns");
    import listCategory from "@/components/budgetreport/ListCategory";

	export default {
		components: {
			VueGoodTable,
            listCategory
		},
		data() {
			return {
                inputStatus: "",
                inputReportYear: new Date().getFullYear(),
				inputCate: "",
				listSearchCate: [{
                    value: -1,
                    label: "Tất cả"
                }],
                inputPeriod: -1,
                inputPeriodDetail: -1,
                listCate: [],
                listPeriodDetail: [],
                tableData:[]
			};
		},
        computed: {
            listStatus() {
                return [
                    {
                        value: -1,
                        label: "Tất cả"
                    },
                    {
                        value: 1,
                        label: "Sử dụng"
                    },
                    {
                        value: 0,
                        label: "Không sử dụng"
                    }
                ]
            },
            listPeriod() {
                return [
                    {
                        label: "Tất cả",
                        value: -1,
                    },
                    {
                        label: "Năm",
                        value: 4,
                    },
                    {
                        label: "Nửa năm",
                        value: 3,
                    },
                    {
                        label: "Tháng",
                        value: 1,
                    },
                    {
                        label: "Quý",
                        value: 2,
                    },
                    {
                        label: "9 tháng",
                        value: 5,
                    },
                ]
            },
            listMonth() {
                return [
                    {
                        label: "Tháng 1",
                        value: 1,
                    },
                    {
                        label: "Tháng 2",
                        value: 2,
                    },
                    {
                        label: "Tháng 3",
                        value: 3,
                    },
                    {
                        label: "Tháng 4",
                        value: 4,
                    },
                    {
                        label: "Tháng 5",
                        value: 5,
                    },
                    {
                        label: "Tháng 6",
                        value: 6,
                    },
                    {
                        label: "Tháng 7",
                        value: 7,
                    },
                    {
                        label: "Tháng 8",
                        value: 8,
                    },
                    {
                        label: "Tháng 9",
                        value: 9,
                    },
                    {
                        label: "Tháng 10",
                        value: 10,
                    },
                    {
                        label: "Tháng 11",
                        value: 11,
                    },
                    {
                        label: "Tháng 12",
                        value: 12,
                    },
                ]
            },
            listQuarter() {
                return [
                    {
                        label: "Quý 1",
                        value: 1,
                    },
                    {
                        label: "Quý 2",
                        value: 2,
                    },
                    {
                        label: "Quý 3",
                        value: 3,
                    },
                    {
                        label: "Quý 4",
                        value: 4,
                    },
                ]
            },
            listHalfYear() {
                return [
                    {
                        label: "6 tháng đầu năm",
                        value: 1,
                    },
                    {
                        label: "6 tháng cuối năm",
                        value: 2,
                    },
                ]
            },
            columns() {
                return [
					{
						label: "STT",
						field: "index",
						type: "number",
						tdClass: "text-center",
						thClass: "text-center",
						width: "50px",
					},
					{
						label: "Danh mục",
						field: "item_name",
						thClass: "text-center",
					},
					{
						label: "Số báo cáo",
						type: "number",
						field: "report_count",
						thClass: "text-center",
                        tdClass: "text-center",
                        width: "200px",
					},
					{
						label: "Tổng số báo cáo",
						type: "number",
						field: "total_count",
						thClass: "text-center",
                        tdClass: "text-center",
                        width: "200px",
					},
				]
            }
        },
		methods: {
            ...mapActions("ui", ["loading", "closeLoading", "notify"]),
			async getData() {
				this.loading(this.$vs);
                this.tableData = (await api.getSummary(this.inputStatus, this.inputPeriod, this.inputPeriodDetail, this.inputReportYear)).data;
				this.closeLoading();
            },
            viewDetail(cateId){
                console.log("1: " + cateId);
                this.$router.push({ path: `/budgetreport/viewer`, query: {cateId: cateId}}).catch(() => {});
            },
            periodChange() {
                if (this.inputPeriod == 1) {
                    this.listPeriodDetail = this.listMonth;
                } else if (this.inputPeriod == 2)
                    this.listPeriodDetail = this.listQuarter;
                else if (this.inputPeriod == 3)
                    this.listPeriodDetail = this.listHalfYear;
                else if (this.inputPeriod == 4){
                    this.listPeriodDetail = [{ value: -1, label: "" }];
                    this.inputPeriodDetail = -1;
                    this.inputReportYear = new Date().getFullYear();
                }
                else if (this.inputPeriod == -1){
                    this.listPeriodDetail = [{ value: -1, label: "" }];
                    this.inputPeriodDetail = -1;
                    this.inputReportYear = -1;
                }
            },

            downloadReport: async function() {
            this.loading(this.$vs);
            const response = await api.exportSummary(this.inputStatus, this.inputPeriod, this.inputPeriodDetail, this.inputReportYear);
            console.log(response);
            this.closeLoading();
            
            if(typeof response === 'undefined' || response.status === 'failed') {
                return this.notify({
                    error: true,
                    text: response.message || "Unknow error",
                })
            }
            //console.log(response);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `thong_ke_van_ban_cong_khai.xlsx`)
            link.click();
            window.URL.revokeObjectURL(url);
            
            }
		},
        async created() {
            this.loading(this.$vs);
            this.listCate = await apiDropdown.getItemsTree('BUDGET_REPORT_CATE');
            for (var i=0; i<this.listCate.length; i++){
                this.listSearchCate.push(this.listCate[i]);
            }
            this.closeLoading();
			await this.getData();
		},
		destroyed() {
			this.closeLoading();
		},
	};
</script>
